exports.ECOSIA_APP_BROWSERS = ['ecosia android', 'ecosia ios'];
